import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

/**
 * Fetch executions for a project with React Query
 * Automatically handles caching, deduplication, and refetching
 */
export const useExecutions = (projectId, options = {}) => {
  const { collectionId, ticketKey, type, limit = 50 } = options;
  
  return useQuery({
    queryKey: ['executions', projectId, collectionId, ticketKey, type],
    queryFn: async () => {
      // console.log('[useExecutions] Fetching executions for projectId:', projectId);
      let url = `/executions?projectId=${projectId}&limit=${limit}`;
      if (collectionId) {
        url += `&collection=${collectionId}`;
      }
      if (ticketKey) {
        url += `&ticketKey=${ticketKey}`;
      }
      if (type) {
        url += `&type=${type}`;
      }
      
      const data = await api.get(url);
      // console.log('[useExecutions] Received data:', data);
      return data.executions || [];
    },
    enabled: !!projectId,
    staleTime: 10000, // 10 seconds
    refetchInterval: (data) => {
      // Auto-refetch every 3 seconds if any execution is running
      const hasRunning = Array.isArray(data) && data.some(e => e.status === 'running' || e.status === 'queued');
      return hasRunning ? 3000 : false;
    }
  });
};

/**
 * Get executions for a specific ticket
 */
export const useTicketExecutions = (projectId, ticketKey, type = null) => {
  // console.log('[useTicketExecutions] Called with:', { projectId, ticketKey, type });
  
  // Pass ticketKey and type to backend for filtering
  const { data: executions = [], isLoading, error, refetch } = useExecutions(projectId, {
    ticketKey,
    type
  });
  
  // console.log('[useTicketExecutions] Executions from backend:', executions);
  
  return {
    executions,
    isLoading,
    error,
    refetch
  };
};
